import { Routes } from '@angular/router';
import { JWTAuthGuard } from 'src/app/core/guards/jwt.guard';
import { OAuth2ConsentPageComponent } from './consent/consent.component';
import { ErrorPageComponent } from './error/error.component';
import { JoinOrganizationPageComponent } from './join-organization/join-organization.component';
import { LoginPageComponent } from './login/login.component';
import { MaintenancePageComponent } from './maintenance/maintenance.component';
import { NewOrganizationPageComponent } from './new-organization/new-organization.component';
import { PublicNotificationPreferencesPageComponent } from './notification-preferences/notification-preferences.component';
import { PublicPageComponent } from './public.component';
import { RecoveryPageComponent } from './recovery/recovery.component';
import { AuthCodePageComponent } from './auth-code/auth-code.component';
import { RegisterPageComponent } from './register/register.component';
import { VerificationPageComponent } from './verification/verification.component';

export const PublicRoutes: Routes = [
  {
    path: '',
    component: PublicPageComponent,
    children: [
      {
        path: 'maintenance',
        component: MaintenancePageComponent,
      },
      {
        path: 'login',
        component: LoginPageComponent,
      },
      {
        path: 'register',
        component: RegisterPageComponent,
      },
      {
        // the code from sign-up and login mails (`?flow=…&code=…`)
        path: 'register/code',
        component: AuthCodePageComponent,
      },
      {
        path: 'recovery',
        component: RecoveryPageComponent,
      },
      {
        path: 'self-service/verification',
        component: VerificationPageComponent,
      },
      {
        // Kratos's verification `ui_url`; keeps `?flow=…&code=…`
        path: 'verify',
        redirectTo: 'self-service/verification',
      },
      {
        path: 'organizations/new',
        component: NewOrganizationPageComponent,
        data: {
          title: 'New Organization',
          icon: 'pi-home',
        },
      },
      {
        // language and timezone are part of onboarding now
        path: 'localization',
        redirectTo: '/onboarding',
      },
      {
        path: 'organizations/join',
        component: JoinOrganizationPageComponent,
      },
      {
        path: 'consent',
        component: OAuth2ConsentPageComponent,
      },
      {
        path: 'notification-preferences',
        component: PublicNotificationPreferencesPageComponent,
        canActivate: [JWTAuthGuard],
      },
      {
        path: 'error',
        component: ErrorPageComponent,
      },
    ],
  },
];
